(function() {
    'use strict';

    angular.module('product.constants', [])
        .constant('productCountryConst', [{
            code: 'PL',
            name_pl: 'Polska',
            name_en: 'Poland'
        }, {
            code: 'DE',
            name_pl: 'Niemcy',
            name_en: 'Germany'
        }])
        .constant('categoryMessagesConst', {
            add: 'Dodano nową kategię!',
            update: 'Dane kategorii zostały zaktualizowane!',
            delete: 'Kategoria została usunięta!',
            error: 'Wystąpił bład!',
            positionChanged: 'Pozycja została zmieniona.'
        })
        .constant('categoryPermissionsConst', {
            view: {
                value: 'view_category',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu kategorii!'
            },
            add: {
                value: 'add_category',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania kategorii!'
            },
            update: {
                value: 'change_category',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji kategorii!'
            },
            delete: {
                value: 'delete_category',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania kategorii!'
            }
        })
        .constant('productMessagesConst', {
            add: 'Dodano nowy produkt!',
            update: 'Dane produktu zostały zaktualizowane!',
            delete: 'Produkt został usunięty!',
            error: 'Wystąpił bład!',
            copy: 'Produkt zosał skopiowany.',
            publishMany: 'Wybrane produkty zostały opublikowane.',
            productsEmptyError: 'Nie wybrano żadnych produktów.',
            unpublishMany: 'Wybrane produkty zostały wyłączone.',
            positionChanged: 'Pozycja została zmieniona.'
        })
        .constant('productPermissionsConst', {
            view: {
                value: 'view_product',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu produktów!'
            },
            add: {
                value: 'add_product',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania produktów!'
            },
            update: {
                value: 'change_product',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji produktów!'
            },
            delete: {
                value: 'delete_product',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania produktów!'
            }
        })
        .constant('productgalleryPermissionsConst', {
            view: {
                value: 'view_productgallery',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu galerii produktu!'
            },
            add: {
                value: 'add_productgallery',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania galerii produktu!'
            },
            update: {
                value: 'change_productgallery',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji galerii produktu!'
            },
            delete: {
                value: 'delete_productgallery',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania galerii produktu!'
            }
        })
        .constant('productoptionpricePermissionsConst', {
            view: {
                value: 'view_productoptionprice',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu cen opcji!'
            },
            add: {
                value: 'add_productoptionprice',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania cen opcji!'
            },
            update: {
                value: 'change_productoptionprice',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji cen opcji!'
            },
            delete: {
                value: 'delete_productoptionprice',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania cen opcji!'
            }
        })
        .constant('packageMessagesConst', {
            add: 'Dodano nową grupę pakowania!',
            update: 'Dane paczki zostały zaktualizowane!',
            delete: 'Paczka została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('packagePermissionsConst', {
            view: {
                value: 'view_package',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu grup pakowania!'
            },
            add: {
                value: 'add_package',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania grup pakowania!'
            },
            update: {
                value: 'change_package',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji grup pakowania!'
            },
            delete: {
                value: 'delete_package',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania grup pakowania!'
            }
        })
        .constant('inpostLockerLimitMessagesConst', {
            update: 'Limit Paczkomatu został zapisany!'
        })
        .constant('inpostLockerLimitPermissionsConst', {
            view: {
                value: 'view_inpostlockerlimit',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu limitu Paczkomatu!'
            },
            update: {
                value: 'change_inpostlockerlimit',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji limitu Paczkomatu!'
            }
        })
        .constant('productParameterMessagesConst', {
            add: 'Dodano nowy parametr produktu!',
            update: 'Dane parametru produktu zostały zaktualizowane!',
            delete: 'Parametr produktu został usunięty!',
            error: 'Wystąpił bład!'
        })
        .constant('productParameterPermissionsConst', {
            view: {
                value: 'view_productparameter',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu parametrów produktu!'
            },
            add: {
                value: 'add_productparameter',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania parametrów produktu!'
            },
            update: {
                value: 'change_productparameter',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji parametrów produktu!'
            },
            delete: {
                value: 'delete_productparameter',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania parametrów produktu!'
            }
        })
        .constant('productParameterOptionPermissionsConst', {
            view: {
                value: 'view_productparameteroption',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu opcji parametrów produktu!'
            },
            add: {
                value: 'add_productparameteroption',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania opcji parametrów produktu!'
            },
            update: {
                value: 'change_productparameteroption',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji opcji parametrów produktu!'
            },
            delete: {
                value: 'delete_productparameteroption',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania opcji parametrów produktu!'
            }
        })
        .constant('productQuantityMessagesConst', {
            add: 'Pomyślnie dodano nakład do produktu!',
            update: 'Dane nakładu zostały zaktualizowane!',
            delete: 'Nakład produktu został usunięty!',
            error: 'Wystąpił bład!'
        })
        .constant('productQuantityPermissionsConst', {
            view: {
                value: 'view_quantity',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu nakładów produktu!'
            },
            add: {
                value: 'add_quantity',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania nakładów produktu!'
            },
            update: {
                value: 'change_quantity',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji nakładów produktu!'
            },
            delete: {
                value: 'delete_quantity',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania nakładów produktu!'
            }
        })
        .constant('productOptionGroupMessagesConst', {
            add: 'Dodano nowa grupę!',
            update: 'Dane grupy zostały zaktualizowane!',
            delete: 'Grupa została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('productOptionGroupPermissionsConst', {
            view: {
                value: 'view_productgroupoptions',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu grup opcji!'
            },
            add: {
                value: 'add_productgroupoptions',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania grup opcji!'
            },
            update: {
                value: 'change_productgroupoptions',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji grup opcji!'
            },
            delete: {
                value: 'delete_productgroupoptions',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania grup opcji!'
            }
        })
        .constant('productOptionMessagesConst', {
            add: 'Dodano nową opcję!',
            update: 'Dane opcji zostały zaktualizowane!',
            delete: 'Opcja została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('productOptionPermissionsConst', {
            view: {
                value: 'view_productoption',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu opcji!'
            },
            add: {
                value: 'add_productoption',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania opcji!'
            },
            update: {
                value: 'change_productoption',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji opcji!'
            },
            delete: {
                value: 'delete_productoption',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania opcji!'
            }
        })
        .constant('techlinePermissionsConst', {
            view: {
                value: 'view_techline',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu linii technologicznych'
            },
            add: {
                value: 'add_techline',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania linii technologicznych'
            },
            update: {
                value: 'change_techline',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji linii technologicznych'
            },
            delete: {
                value: 'delete_techline',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania linii technologicznych'
            }
        })
        .constant('exclusionMessagesConst', {
            add: 'Dodano nowe wykluczenie!',
            update: 'Dane wykluczenia zostały zaktualizowane!',
            delete: 'Wykluczenie zostało usunięte!',
            error: 'Wystąpił bład!'
        })
        .constant('exclusionPermissionsConst', {
            view: {
                value: 'view_productoptionexclusion',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu wykluczeń!'
            },
            add: {
                value: 'add_productoptionexclusion',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania wykluczeń!'
            },
            update: {
                value: 'change_productoptionexclusion',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji wykluczeń!'
            },
            delete: {
                value: 'delete_productoptionexclusion',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania wykluczeń!'
            }
        })
        .constant('productGalleryMessagesConst', {
            add: 'Do galerii zostało dodane nowe zdjęcie!',
            delete: 'Zdjęcie zostało usunięte!',
            error: 'Wystąpił bład!',
            defaultMessage: 'Dodaj zdjęcia do galerii.'
        })
        .constant('discountMessagesConst', {
            listError: 'Nie udało się pobrać listy rabatów.',
            updateSuccess: 'Rabat został zaktualizowany.',
            updateManySuccess: 'Rabaty zostały zaktualizowane.',
            updateManyError: 'Błąd podczas aktualizacji rabatów.'
        })
        .constant('discountPermissionsConst', {
            view: {
                value: 'view_discount',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu rabatów!'
            },
            add: {
                value: 'add_discount',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania rabatów!'
            },
            update: {
                value: 'change_discount',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji rabatów!'
            },
            delete: {
                value: 'delete_discount',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania rabatów!'
            }
        });
})();
